module.exports = __webpack_public_path__ + "img/icon_review2.7c946433.png";